// extracted by mini-css-extract-plugin
module.exports = {"container":"Textarea_container__wR3We","label":"Textarea_label__XXl7I","bottomLabel":"Textarea_bottomLabel__eacPS"};